import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  OWL_DATE_TIME_FORMATS,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from 'ng-pick-datetime';

import { MomentInBoundComponent } from './moment-in-bound.component';
import { MY_NATIVE_FORMATS } from './moment-in-bound.constants';

@NgModule({
  imports: [CommonModule, OwlDateTimeModule, OwlNativeDateTimeModule],
  declarations: [MomentInBoundComponent],
  exports: [MomentInBoundComponent],
  providers: [{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS }],
})
export class MomentInBoundComponentModule {}
